// @ts-nocheck
import React from 'react';
import { Box, ThemeProvider, Stack } from '@mui/material';
import { createModifiedTheme } from '../Theme';
import RejectPopper from './components/RejectPopper';
import SignModule from './SignModule';
import RejectModule from './RejectModule';
import ApprovedModule from './ApprovedModule';
import { useClientStyles } from '../Styles';
import LinkExpired from '../LinkExpired';
import useRejectApproveConfirm from '../hooks/useRejectApproveConfirm';
import { useBrowserLocation } from '../../DayworkDocketDetailView/hooks/useBrowserLocation';

const emailExternalTheme = createModifiedTheme();

const SignPortal = () => {
  const classes = useClientStyles();
  const { location, address } = useBrowserLocation();

  const {
    isExpired,
    isRejected,
    setIsRejected,
    isApproved,
    open,
    handleClose,
    handleClickOpen,
    handleApproved,
    rejectedMessage,
    approvalMessage,
    approveRejectDocument,
    comment,
    setComment,
    signatoryName,
    setSignatoryName,
  } = useRejectApproveConfirm(location, address);

  return (
    <ThemeProvider theme={emailExternalTheme}>
      {isExpired ? (
        <LinkExpired />
      ) : (
        <Box className={classes.root}>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            className={classes.stack}
            px={{ xs: 0, sm: 3 }}
            py={{ xs: 0, sm: 3 }}
          >
            {!isRejected && !isApproved && (
              <SignModule
                handleClickOpen={handleClickOpen}
                handleApproved={handleApproved}
                comment={comment}
                setComment={setComment}
                signatoryName={signatoryName}
                setSignatoryName={setSignatoryName}
              />
            )}
            {isRejected && <RejectModule rejectedMessage={rejectedMessage} />}
            {isApproved && <ApprovedModule approvalMessage={approvalMessage} />}
          </Stack>
        </Box>
      )}
      <RejectPopper
        open={open}
        setIsRejected={setIsRejected}
        handleClose={handleClose}
        approveRejectDocument={approveRejectDocument}
      />
    </ThemeProvider>
  );
};

export default SignPortal;
